import React, { memo } from 'react'

import { func, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { getMultiViewConstraints } from 'Pods/ThreeDStudio/Shared/Utils/getMultiViewConstraints'
import { viewLabelKey } from 'Pods/ThreeDStudio/Shared/Utils/viewLabelKeys'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { VIEW_TYPE } from 'Pods/ThreeDStudio/Store/constants'

import ViewSlot from './Components/ViewSlot/ViewSlot'

// Grid order follows the design; each provider's schema decides which of these show.
const VIEW_TYPES = Object.values(VIEW_TYPE)

function MultiViewUploader({ sliceName, storeSchemaKey, setInputViewImage }) {
  const t = useTranslation()
  const inputViewImages = useThreeDStudioStore(state => state[sliceName].inputViewImages)
  const inputImageSchema = useThreeDStudioStore(
    state => state.schema[storeSchemaKey]?.input_schema?.properties?.input_image
  )

  const { viewTypes, maxItems } = getMultiViewConstraints(inputImageSchema)
  const slots = VIEW_TYPES.filter(viewType => viewTypes.includes(viewType))
  const imageUrlFor = viewType => inputViewImages?.[viewType]?.url
  const filledCount = slots.filter(viewType => !!imageUrlFor(viewType)).length
  // Once the provider's image cap is reached the empty slots stop accepting files;
  // filled ones stay live so a view can still be replaced or removed.
  const isAtCapacity = filledCount >= maxItems

  return (
    <div
      className="multi-view-uploader"
      role="group"
      aria-label={t('shared.actionSelector.imageUploader.multiView.title')}
    >
      {slots.map((viewType) => {
        const imageUrl = imageUrlFor(viewType)

        return (
          <ViewSlot
            key={viewType}
            viewType={viewType}
            label={t(viewLabelKey(viewType))}
            imageUrl={imageUrl}
            setInputViewImage={setInputViewImage}
            storeSchemaKey={storeSchemaKey}
            sliceName={sliceName}
            disabled={isAtCapacity && !imageUrl}
          />
        )
      })}
    </div>
  )
}

MultiViewUploader.propTypes = {
  sliceName: string.isRequired,
  storeSchemaKey: string.isRequired,
  setInputViewImage: func.isRequired,
}

export default memo(MultiViewUploader)
